import {GetArrayFromRecursive, GetFlatArrayFromRecursive} from "../../../helpers/CoreHelpers";

const initialState = {
    items: [],
    single: {},
    refresh: false,
    loading: false,
    filtered: [],
    flat: [],
    select: [],
};

export default (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case 'PUBLIC_FORMS_RESET':
            return initialState;

        case 'PUBLIC_FORM_SINGLE_SUCCESS':
            return {
                ...state,
                single: action.payload.data,
                loading: false,
            };

        case 'PUBLIC_FORMS_STRUCTURE_LOADING':
            if (payload.skipStore === false) {
                return {
                    ...state,
                    loading: true
                }
            } else {
                return {
                    ...state
                }
            }

        case 'PUBLIC_FORMS_STRUCTURE_SUCCESS':
            let formEntries = [];

            for (let x in payload.data) {
                formEntries.push({
                    ...JSON.parse(payload.data[x].data),
                    contentId: payload.data[x].contentId,
                    id: payload.data[x].id
                });
            }

            if (payload.skipStore === false) {
                return {
                    ...state,
                    items: formEntries,
                    filtered: formEntries,
                    flat: GetFlatArrayFromRecursive(formEntries),
                    select: GetArrayFromRecursive(formEntries),
                    loading: false
                };
            } else {
                return {
                    ...state
                }
            }

        case 'PUBLIC_FORMS_STRUCTURE_FAILED':
            if (payload.skipStore === false) {
                return {
                    ...state,
                    loading: false
                }
            } else {
                return {
                    ...state
                }
            }

        case 'FORM_ITEM_DESTROY_SUCCESS':
            return {
                ...state,
                refresh: true
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/publicForms.js